<script setup>
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faStar as farStar } from '@fortawesome/free-regular-svg-icons'
import Rating from '@/components/ui/rating.vue'

const props = defineProps({
  isCancelled: {
    type: Boolean,
    default: false
  },
  isExpired: {
    type: Boolean,
    default: false
  },
  isStale: {
    type: Boolean,
    default: false
  }
})

// I18n
const { t } = useI18n()

// Variables
const isLoading = ref(true)

onMounted(async () => {
})

</script>

<template>
  <div class="relative flex flex-col rounded-xl border border-black bg-white w-full p-8 mb-8 shimmer-container" :class="{ 'cancelled': isCancelled || isExpired || isStale }">
    <div class="flex flex-col md:flex-row  mt-2">
      <div class="h-24 w-24 rounded-xl border bg-gray-100 overflow-hidden"></div>

      <div class="flex flex-col-reverse md:flex-col grow md:px-4 mb-2">
        <h3 class="text-2xl font-semibold mb-2 md:mb-6">
          <template v-if="isCancelled">{{ t('my_garage.quotes.quote_cancelled') }}</template>
          <template v-else-if="isExpired">{{ t('my_garage.quotes.quote_expired') }}</template>
          <template v-else-if="isStale">{{ t('my_garage.quotes.quote_stale') }}</template>
          <template v-else>{{ t('my_garage.quotes.finding_service_provider') }}</template>
        </h3>

        <div class="p-2">
<!--          <rating :value="0" :count="null"></rating>-->
        </div>
      </div>

      <div class="md:text-right">
        <p class="text-3xl font-semibold mb-2">
          <template v-if="isCancelled || isExpired || isStale">{{ t('my_garage.quotes.no_price_available') }}</template>
          <template v-else>{{ t('my_garage.quotes.gathering_price') }}</template>
        </p>
      </div>
    </div>
    <div class="flex flex-col mt-6">
      <p class="text-gray-500">
        {{ t('my_garage.quotes.disclaimer_blurb') }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/styles/views/my_garage/quote';

.shimmer-container {
  position: relative;
  overflow: hidden;
}

.shimmer-container:not(.cancelled)::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.6),
    transparent
  );
  animation: shimmer 3s infinite;
  z-index: 1;
  pointer-events: none;
}

@keyframes shimmer {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
</style>
